export default (
  <svg xmlns="http://www.w3.org/2000/svg" width="259" height="194">
    <path style={{ fill: "#dbdbdb", stroke: "none" }} d="M0 0L0 194L259 194L259 0L0 0z" />
    <path style={{ fill: "#9c9c9c", stroke: "none" }} d="M91 70L91 124L92 124L92 88L91 70z" />
    <path style={{ fill: "#7c7c7c", stroke: "none" }} d="M92 70L92 71L168 71L144 70L92 70z" />
    <path style={{ fill: "#545454", stroke: "none" }} d="M92 71L92 124L168 124L168 71L92 71z" />
    <path style={{ fill: "#9c9c9c", stroke: "none" }} d="M98 77L99 78L98 77z" />
    <path style={{ fill: "#b3b3b3", stroke: "none" }} d="M98 78L98 79C117.3 74.405 141.164 78 161 78L143 77L98 78z" />
    <path style={{ fill: "#dbdbdb", stroke: "none" }} d="M99 78L99 117L161 117L161 78L99 78z" />
    <path
      style={{ fill: "#9c9c9c", stroke: "none" }}
      d="M98 79L98 106L99.0278 116.397L115 118L161 118L161 117L99 117C99 106.089 102.211 89.0359 98 79z"
    />
    <path style={{ fill: "#b3b3b3", stroke: "none" }} d="M144 82L144 83L147 83L144 82z" />
    <path style={{ fill: "#7c7c7c", stroke: "none" }} d="M143 83L144 84L143 83z" />
    <path
      style={{ fill: "#545454", stroke: "none" }}
      d="M144.225 83.8009C138.813 85.7916 142.569 93.5 147.769 91.3773C152.728 89.3528 148.916 82.0752 144.225 83.8009z"
    />
    <path
      style={{ fill: "#7c7c7c", stroke: "none" }}
      d="M148 83L149 84L148 83M149 84L150 85L149 84M141 85L142 86L141 85z"
    />
    <path style={{ fill: "#9c9c9c", stroke: "none" }} d="M150 85L151 86L150 85z" />
    <path style={{ fill: "#7c7c7c", stroke: "none" }} d="M150 86L151 87L150 86z" />
    <path
      style={{ fill: "#b3b3b3", stroke: "none" }}
      d="M140.333 87.6667L140.667 88.3333L140.333 87.6667M112 89L113 90L112 89z"
    />
    <path style={{ fill: "#7c7c7c", stroke: "none" }} d="M113 89L112 91L113 89M150 89L151 90L150 89z" />
    <path
      style={{ fill: "#545454", stroke: "none" }}
      d="M113 90C108.334 96.5546 103.197 104.825 103 113L153 113L153 112L133 96L129 105L113 90z"
    />
    <path style={{ fill: "#9c9c9c", stroke: "none" }} d="M114 90L115 91L114 90M141 90L142 91L141 90z" />
    <path style={{ fill: "#b3b3b3", stroke: "none" }} d="M111 91L112 92L111 91z" />
    <path style={{ fill: "#9c9c9c", stroke: "none" }} d="M115 91L116 92L115 91M142 91L143 92L142 91z" />
    <path style={{ fill: "#b3b3b3", stroke: "none" }} d="M149 91L150 92L149 91z" />
    <path style={{ fill: "#9c9c9c", stroke: "none" }} d="M116 92L117 93L116 92z" />
    <path style={{ fill: "#b3b3b3", stroke: "none" }} d="M143 92L144 93L143 92z" />
    <path style={{ fill: "#7c7c7c", stroke: "none" }} d="M144 92L144 93L147 93L144 92z" />
    <path
      style={{ fill: "#9c9c9c", stroke: "none" }}
      d="M147 92L148 93L147 92M110 93L111 94L110 93M117 93L118 94L117 93z"
    />
    <path style={{ fill: "#b3b3b3", stroke: "none" }} d="M118 94L119 95L118 94z" />
    <path style={{ fill: "#9c9c9c", stroke: "none" }} d="M109 95L110 96L109 95z" />
    <path
      style={{ fill: "#b3b3b3", stroke: "none" }}
      d="M119 95L120 96L119 95M133 95L134 96L133 95M120 96L121 97L120 96z"
    />
    <path style={{ fill: "#7c7c7c", stroke: "none" }} d="M134 96L135 97L134 96M108 97L109 98L108 97z" />
    <path style={{ fill: "#b3b3b3", stroke: "none" }} d="M121 97L122 98L121 97z" />
    <path
      style={{ fill: "#7c7c7c", stroke: "none" }}
      d="M132 97L133 98L132 97M135 97L136 98L135 97M107 99L108 100L107 99M131 99L132 100L131 99z"
    />
    <path
      style={{ fill: "#b3b3b3", stroke: "none" }}
      d="M138 99L139 100L138 99M106 100L107 101L106 100M130 100L131 101L130 100M139 100L140 101L139 100z"
    />
    <path style={{ fill: "#7c7c7c", stroke: "none" }} d="M106 101L107 102L106 101z" />
    <path style={{ fill: "#9c9c9c", stroke: "none" }} d="M140 101L141 102L140 101z" />
    <path style={{ fill: "#b3b3b3", stroke: "none" }} d="M105 102L106 103L105 102z" />
    <path style={{ fill: "#7c7c7c", stroke: "none" }} d="M125 102L126 103L125 102z" />
    <path style={{ fill: "#9c9c9c", stroke: "none" }} d="M129 102L130 103L129 102M141 102L142 103L141 102z" />
    <path
      style={{ fill: "#7c7c7c", stroke: "none" }}
      d="M105 103L106 104L105 103M126 103L127 104L126 103M142 103L143 104L142 103z"
    />
    <path style={{ fill: "#9c9c9c", stroke: "none" }} d="M104 104L105 105L104 104z" />
    <path
      style={{ fill: "#7c7c7c", stroke: "none" }}
      d="M127.667 104.333L128.333 104.667L127.667 104.333M143 104L144 105L143 104z"
    />
    <path style={{ fill: "#9c9c9c", stroke: "none" }} d="M103 106L104 107L103 106z" />
    <path style={{ fill: "#b3b3b3", stroke: "none" }} d="M146 106L147 107L146 106M147 107L148 108L147 107z" />
    <path style={{ fill: "#9c9c9c", stroke: "none" }} d="M148 108L149 109L148 108z" />
    <path style={{ fill: "#7c7c7c", stroke: "none" }} d="M149 109L150 110L149 109M150 110L151 111L150 110z" />
    <path style={{ fill: "#b3b3b3", stroke: "none" }} d="M153 112L154 113L153 112z" />
    <path style={{ fill: "#7c7c7c", stroke: "none" }} d="M98 117L99 118L98 117z" />
    <path style={{ fill: "#b3b3b3", stroke: "none" }} d="M92 124L92 125L168 125L144 124L92 124z" />
  </svg>
)
